import classNames from 'classnames';
import { FC } from 'react';
import { localeStore } from '~/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  value: string;
  error: string | null;
  onChange: (value: string | undefined) => void;
}

export const VatRegNumber: FC<IProps> = ({ value, error, onChange }): JSX.Element => {
  return (
    <div className="vat-reg-number">
      <Text text="vat_registration_number" type={TEXT.SECTION_HEADER} />
      <div className="d-flex flex-column mt-4">
        <Input
          value={value}
          type="number"
          onChangeValue={onChange}
          placeholder={localeStore.t('Value')}
          contentClassName={classNames('w-100', { 'input-error': error })}
        />
        {error ? <Text text={error} type={TEXT.ERROR} /> : null}
      </div>
    </div>
  );
};
